<template>
  <span v-if="element.type == 'button'">
    <!-- tabindex: tap focuses the word on touch screens, which opens the popover -->
    <div
      :id="getId()"
      class="unsafe-word"
      tabindex="0"
    >{{element.meaning.word}}</div>
    <b-popover
      :target="getId()"
      triggers="hover focus"
      placement="top"
      variant="warning"
    >
      <template v-slot:title>{{element.meaning.word}}</template>
      <Meaning
        as="plain"
        v-bind:taiwan="element.meaning.chinaUsage.taiwan"
        v-bind:china="element.meaning.chinaUsage.china"
        v-bind:english="english"
      ></Meaning>
    </b-popover>
  </span>
  <span v-else-if="element.type == 'text'">{{element.meaning.word}}</span>
</template>

<script>
import Meaning from "@/components/Meaning.vue";

export default {
  name: "SentenceChunk",
  components: {
    Meaning
  },
  props: {
    element: Object,
    index: Number
  },
  computed: {
    english: function() {
      return (this.element.meaning.english || []).join(", ");
    }
  },
  methods: {
    getId: function() {
      return "button-popover-" + this.index;
    }
  }
};
</script>

<style scoped>
.unsafe-word {
  border-radius: 3px;
  background-color: #f1625b;
  color: #082213;
  display: inline;
  cursor: pointer;
}
.unsafe-word:hover,
.unsafe-word:focus {
  background-color: white;
  outline: none;
}
</style>
